export const getLogApi = ( apiInstance: API.Client ) => async ( uid: string ) => {
  const entry = await apiInstance.Entity.collection( 'dataLog' ).get( uid );
  return entry;
};
